import api from "@/api.js";

export default {
  state: {
    items: [],
    itemsLoading: false
  },
  mutations: {
    setItems(state, payload) {
      state.items = payload;
    },
    setItemsLoading(state, payload) {
      state.itemsLoading = payload;
    }
  },
  actions: {
    async loadItems({ commit, state }) {
      let items;

      items = await api.get("items");

      commit("setItems", items.data);
    },
  },
  getters: {
    items(state) {
      return state.items;
    },
    itemsLoading(state) {
      return state.itemsLoading;
    }
  }
};
